export const config ={
    API_URL : 'https://api.underscoretec.com/'
    // API_URL: 'http://localhost:5570/'
}


// WEBPACK FOOTER //
// ./src/config.js